// carousel-config.js

export const cardDetails = {
  0: {
    imgUrl: "https://t3.ftcdn.net/jpg/06/00/92/28/360_F_600922821_wWqDd3DPAuGxAwWK1Vh3cJ4kwbDv3pKq.jpg",
    title: "Services",
    path: "/services",
  },
  1: {
    imgUrl: "https://portfolio-collective-com.b-cdn.net/wp-content/uploads/2021/08/networking-1-1536x1026.png",
    title: "Network",
    path: "/network",
  },
  2: {
    imgUrl: "https://triniti-it-security.com/wp-content/uploads/2024/01/360_F_112975711_Son59ty39doovsHs3az37nLEJ7rGNGPf.jpg",
    title: "Our Expertise",
    path: "/our-expertise",
  },
  3: {
    imgUrl: "https://www.pngkit.com/png/full/65-653152_lions-we-serve-week-logo-lions-clubs-international.png",
    title: "Who We Serve",
    path: "/who-we-serve",
  },
  4: {
    imgUrl: "https://media.istockphoto.com/id/506351726/photo/recruiter-advertising-for-job-vacancies-searching-candidates-to-hire.jpg?s=1024x1024&w=0&k=20&c=9mZD15PyA2oV91sn442jCaNN1dR-72lRJbXXyv9d360=",
    title: "Careers",
    path: "/careers",
  },
  5: {
    imgUrl: "https://media.istockphoto.com/id/1764831872/photo/new-job-recruitment-career.jpg?s=612x612&w=0&k=20&c=wVvX85_IUUnOuSSib_OKZuk4UZ8vzRd6mQcekMPs3gA=",
    title: "Current Opportunities",
    path: "/joblist",
  },
  6: {
    imgUrl: "https://st.depositphotos.com/1038076/4908/i/450/depositphotos_49080337-stock-photo-about-us.jpg",
    title: "About Us",
    path: "/about",
  },
  7: {
    imgUrl: "https://media.istockphoto.com/id/1271752802/photo/phone-and-e-mail-icons-on-wooden-cubes-with-contact-us-text-on-blue-background-web-page.jpg?s=612x612&w=0&k=20&c=dk9oPaDy_L9mv_icOMgsFGzEDrX0NUI3I8xBQ-DAxQM=",
    title: "Contact Us",
    path: "/contact",
  },
};
